export default __webpack_public_path__ + "static/media/22.676c5a0c.mp3";